import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(1800);
  return <div className="sticky top-0 z-40 bg-sage-deep text-white" data-id="element-276" data-mp="234zu8q6zhm7t">
      <div className="mx-auto flex max-w-content flex-col items-center justify-center gap-2 px-4 py-2.5 text-center sm:flex-row sm:gap-5 sm:py-3" data-id="element-277" data-mp="1y4loxfwroqdh">
        <p className="eyebrow text-[10px] leading-tight sm:text-[11.5px]" data-id="element-278" data-mp="2qshrv2cxjeip">
          🎁 Oferta especial de lanzamiento · <span className="text-white" data-id="element-279" data-mp="2ltn2fhkgirpm">5 bonus gratis</span> ·
          Acceso inmediato
        </p>
        <div className="flex items-center gap-1 font-sans text-[11.5px] font-semibold tabular-nums sm:text-[12.5px]" data-id="element-280" data-mp="2h2enk60cye52">
          <span className="rounded bg-white/15 px-1.5 py-0.5" data-id="element-281" data-mp="2c4d59naraiun">{hours}</span>
          <span className="text-white/50" data-id="element-282" data-mp="39iphchnpi6gf">:</span>
          <span className="rounded bg-white/15 px-1.5 py-0.5" data-id="element-283" data-mp="39kk13sn8rsix">{minutes}</span>
          <span className="text-white/50" data-id="element-284" data-mp="34r7pcj3nvg7l">:</span>
          <span className="rounded bg-white/15 px-1.5 py-0.5" data-id="element-285" data-mp="34qfsz628peg9">{seconds}</span>
        </div>
      </div>
    </div>;
}